import { Component, Input } from '@angular/core';
import { makePostalCodeMask } from '@app/functions';
import { TextMask } from '@app/interfaces';
import { TaxForm } from '@app/models/payroll/tax-form.abstract.model';
import { BaseForm } from '@forms/base.form';

/**
 * Allows editing of the employee associated with a T4 or RL-1
 */
@Component({
    selector: 'app-tax-return-employee-form',
    templateUrl: './employee.template.html',
})
export class TaxReturnEmployeeForm extends BaseForm {
    @Input({ required: true })
    taxForm!: TaxForm;

    isLoading = false;

    readonly POSTAL_CODE_MASK: TextMask = makePostalCodeMask();
    readonly EMPLOYEE_DETAILS_MAP: { key: keyof TaxForm; required: boolean }[] = [
        { key: 'firstName', required: true },
        { key: 'lastName', required: true },
        { key: 'sin', required: true },
        { key: 'address1', required: true },
        { key: 'address2', required: false },
        { key: 'address3', required: false },
        { key: 'locality', required: true },
        { key: 'adminArea', required: true },
        { key: 'country', required: true },
        { key: 'postCode', required: true },
    ];
}
